import { render, staticRenderFns } from "./CStatusChip.vue?vue&type=template&id=7f4dadfd&scoped=true&"
import script from "./CStatusChip.vue?vue&type=script&lang=js&"
export * from "./CStatusChip.vue?vue&type=script&lang=js&"
import style0 from "./CStatusChip.vue?vue&type=style&index=0&id=7f4dadfd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4dadfd",
  null
  
)

export default component.exports